export const SENTRY_DSN =
  'https://9e60291e9d874274b95b3a562d8c4797@sentry-next.wixpress.com/8088';
